import {isArray} from 'rxjs/internal-compatibility';

export class HttpError {
    constructor(public message?: string,
                public errors?: { [key: string]: string },
                public error?: string,
                public error_description?: string) {
    }

    static getErrorMessages(error: HttpError): string[] {
        const ErrMessages: string[] = [];
        if (error.errors === undefined) {
            return ErrMessages;
        }
        Object.keys(error.errors).forEach((v) => {
            // @ts-ignore
            if (isArray(error.errors[v])) {
                // @ts-ignore
                error.errors[v].forEach((value) => ErrMessages.push(value))
            }
        });
        return ErrMessages
    }
}
